import React, * as r from 'react';
import Blog from '../templetes/Blog'
import { Stores } from '../../services/store'


const Top = () => {

  return (
    <Blog />
  );
}

export default Top
